import { StatisticsEndpoints } from "shared/models/endpoits/statistics.endpoint";

import { IStatisticsResponse } from "shared/models/interfaces/response/statistics.interface";
import { getRequest } from "./base-services.request";

export interface IStatisticsFilters {}
export const getStatistics = (
  filters?: IStatisticsFilters
): Promise<IStatisticsResponse> => {
  return getRequest(StatisticsEndpoints.statistics, filters).then(
    (response) => response?.data
  );
};


